import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { nothing as w, html as $, render as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './card-gallery-with-filters.scss.js';
import { CardGalleryStateController } from './logic/store.js';
import { renderCard } from './ui/card.js';
import { renderPagination } from './ui/pagination.js';
import { renderFilters } from './ui/filters.js';
import { renderCourseModal } from './ui/modal/modal.js';
import { ensureModalPortalStyles } from './ui/modal/modal-portal-styles.js';
import { modalPortalCss } from './ui/modal/modal-portal.css.js';
import { getOrCreateModalPortal, removeModalPortalIfEmpty } from './ui/modal/modal-portal.js';
import './mappers/simple.mapper.js';
import './mappers/courses.mapper.js';

class CardGalleryWithFilters extends s {
    constructor() {
        super(...arguments);
        this.controller = new CardGalleryStateController(this);
        this.endpoint = '';
        this.leftTitle = '';
        this.rightTitle = '';
        this.searchLabel = '';
        this.selectALabel = '';
        this.selectAOptions = [];
        this.selectBLabel = '';
        this.selectBOptions = [];
        this.pageSize = 9;
        this.isRtl = '';
        this.mapper = 'simple';
        this.requestHeaders = {};
        this.items = [];
        this.totalItems = 0;
        this.page = 1;
        this.search = '';
        this.selectedA = '';
        this.selectedB = '';
        this.isLoading = false;
        this.isModalOpen = false;
        this.activeItem = null;
        this.handleEscapeKey = (event) => {
            if (event.key === 'Escape' && this.isModalOpen) {
                this.closeModal();
            }
        };
        this.openModal = (item) => {
            this.activeItem = item;
            this.isModalOpen = true;
        };
        this.closeModal = () => {
            this.isModalOpen = false;
            this.activeItem = null;
        };
    }
    connectedCallback() {
        super.connectedCallback();
        ensureModalPortalStyles(modalPortalCss);
        this.controller.initialize();
        window.addEventListener('keydown', this.handleEscapeKey);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener('keydown', this.handleEscapeKey);
        if (typeof window !== 'undefined') {
            this.isModalOpen = false;
            this.activeItem = null;
            this.renderModalInPortal();
        }
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        const modalStateChanged = changedProperties.has('isModalOpen') ||
            changedProperties.has('activeItem');
        if (modalStateChanged) {
            this.renderModalInPortal();
        }
    }
    renderCards() {
        if (!this.items.length)
            return w;
        return $ `${this.items.map(card => renderCard(card, this.openModal))}`;
    }
    renderLoader() {
        if (!this.isLoading) {
            return w;
        }
        return $ `<p class="gallery-loading">Loading...</p>`;
    }
    renderPaginationSection() {
        if (this.isLoading) {
            return w;
        }
        if (this.totalItems <= this.pageSize) {
            return w;
        }
        return renderPagination(this.page, this.totalItems, this.pageSize, pageNum => this.controller.goToPage(pageNum));
    }
    renderModalInPortal() {
        if (typeof window === 'undefined') {
            return;
        }
        const portal = getOrCreateModalPortal();
        const modalTemplate = renderCourseModal(this.isModalOpen, this.activeItem, this.closeModal);
        x(modalTemplate, portal);
        if (!this.isModalOpen) {
            removeModalPortalIfEmpty();
        }
    }
    renderNoResultsMessage() {
        if (this.isLoading) {
            return w;
        }
        if (!this.search) {
            return w;
        }
        if (this.items.length > 0) {
            return w;
        }
        return $ `<div class="gallery-no-results" role="status" aria-live="polite"><p>Your search for '<strong>${this.search}</strong>' did not return any results.</p></div>`;
    }
    render() {
        const direction = this.isRtl === 'isRtl' ? 'rtl' : 'ltr';
        const filtersTemplate = renderFilters(this.searchLabel, this.search, value => this.controller.updateSearch(value), this.selectALabel, this.selectAOptions, this.selectedA, value => this.controller.updateSelectA(value), this.selectBLabel, this.selectBOptions, this.selectedB, value => this.controller.updateSelectB(value), this.leftTitle, this.rightTitle);
        const loaderTemplate = this.renderLoader();
        const cardsTemplate = this.isLoading ? w : this.renderCards();
        const paginationTemplate = this.renderPaginationSection();
        const noResultsTemplate = this.renderNoResultsMessage();
        return $ `<section class="gallery-section" dir="${direction}">${filtersTemplate} ${loaderTemplate} ${noResultsTemplate}<div class="gallery-grid">${cardsTemplate}</div>${paginationTemplate}</section>`;
    }
}
CardGalleryWithFilters.styles = css_248z;
__decorate([
    e({ type: String })
], CardGalleryWithFilters.prototype, "endpoint", void 0);
__decorate([
    e({ type: String })
], CardGalleryWithFilters.prototype, "leftTitle", void 0);
__decorate([
    e({ type: String })
], CardGalleryWithFilters.prototype, "rightTitle", void 0);
__decorate([
    e({ type: String })
], CardGalleryWithFilters.prototype, "searchLabel", void 0);
__decorate([
    e({ type: String })
], CardGalleryWithFilters.prototype, "selectALabel", void 0);
__decorate([
    e({ type: Array })
], CardGalleryWithFilters.prototype, "selectAOptions", void 0);
__decorate([
    e({ type: String })
], CardGalleryWithFilters.prototype, "selectBLabel", void 0);
__decorate([
    e({ type: Array })
], CardGalleryWithFilters.prototype, "selectBOptions", void 0);
__decorate([
    e({ type: Number })
], CardGalleryWithFilters.prototype, "pageSize", void 0);
__decorate([
    e({ type: String })
], CardGalleryWithFilters.prototype, "isRtl", void 0);
__decorate([
    e({ type: String })
], CardGalleryWithFilters.prototype, "mapper", void 0);
__decorate([
    e({ type: Object })
], CardGalleryWithFilters.prototype, "requestHeaders", void 0);
__decorate([
    t()
], CardGalleryWithFilters.prototype, "items", void 0);
__decorate([
    t()
], CardGalleryWithFilters.prototype, "totalItems", void 0);
__decorate([
    t()
], CardGalleryWithFilters.prototype, "page", void 0);
__decorate([
    t()
], CardGalleryWithFilters.prototype, "search", void 0);
__decorate([
    t()
], CardGalleryWithFilters.prototype, "selectedA", void 0);
__decorate([
    t()
], CardGalleryWithFilters.prototype, "selectedB", void 0);
__decorate([
    t()
], CardGalleryWithFilters.prototype, "isLoading", void 0);
__decorate([
    t()
], CardGalleryWithFilters.prototype, "isModalOpen", void 0);
__decorate([
    t()
], CardGalleryWithFilters.prototype, "activeItem", void 0);
customElements.define('card-gallery-with-filters', CardGalleryWithFilters);

export { CardGalleryWithFilters };
